import template from '@components/expertise/discovery/discovery.module.scss'
import { IdiscoveryArtifactsSection } from '../../discovery.state'
import style from './index.module.scss'
import Image from 'next/image'

interface discoveryArtifactsSectionProps {
    section: IdiscoveryArtifactsSection;
}

const DiscoveryArtifactsSectionComponent = ({section}: discoveryArtifactsSectionProps) => {
    return(
        <section className={`${template.section} ${template.section__block_light}`}>
                <div className={template.container}>
                    <h2 className={template.steps__title}>
                        {section.title}
                    </h2>
                    <div className={template.steps__image_large}>
                        <Image src={section.imgSrc} layout={'fill'} alt={section.title} />
                    </div>
                </div>
            </section>
    )
}

export default DiscoveryArtifactsSectionComponent;